import React from 'react';

export const UnauthorizedPage = () => (
  <div>
    403 - You are not allowed to view this page
  </div>
);
